import { GridInitialStateCommunity } from '@mui/x-data-grid/models/gridStateCommunity';
import { EventGrid } from 'components/event/layout/EventGrid';
import { EventTable } from 'components/event/layout/EventTable';
import { EventOccasion } from 'models/EventOccasion';

export enum EventListLayout {
  Grid = 0,
  Table = 1,
}

export interface EventListProps {
  eventList: EventOccasion[];
  onDeleteEvent?: (event: EventOccasion) => void;
  onRestoreEvent?: (event: EventOccasion) => void;
  initialState?: GridInitialStateCommunity;
  layout?: EventListLayout;
}

export function EventList(props: EventListProps) {
  const layout: EventListLayout = props.layout || EventListLayout.Grid;
  props.eventList.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  return (
    <>
      {layout === EventListLayout.Grid && (
        <EventGrid
          eventList={props.eventList}
          onDeleteEvent={(event) => props.onDeleteEvent?.(event)}
          onRestoreEvent={(event) => props.onRestoreEvent?.(event)}
        />
      )}
      {layout === EventListLayout.Table && (
        <EventTable
          eventList={props.eventList}
          onDeleteEvent={(event) => props.onDeleteEvent?.(event)}
          onRestoreEvent={(event) => props.onRestoreEvent?.(event)}
        />
      )}
    </>
  );
}
